var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocalizationArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8332 14.5H21.1665V16.8333H18.8332V14.5ZM18.8332 9.83333H21.1665V12.1667H18.8332V9.83333ZM18.8332 5.16667H21.1665V7.5H18.8332V5.16667ZM15.0298 5.16667L16.4998 6.14667V5.16667H15.0298Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 0.5V2.26167L12.9998 3.81333V2.83333H23.4998V19.1667H18.8332V21.5H25.8332V0.5H10.6665Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5315 3.65L16.4998 8.95833V21.5H0.166504V9.22667L8.5315 3.65ZM10.6665 19.1667H14.1665V10.02L8.5315 6.43833L2.49984 10.2767V19.1667H5.99984V12.1667H10.6665V19.1667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocalizationArea);
export default __webpack_public_path__ + "static/media/icon_localization_area.313b05eedca22f9dbeb0f8e1905f65d1.svg";
export { ForwardRef as ReactComponent };